export const DenialReasonFieldTestIds = {
  getReasonInputId: index => `denial-reason-${index}.reason-input`,
  getAffiliateCheckboxId: index => `denial-reason-${index}.affiliate-checkbox`,
  getCreditDenialCheckboxId: index => `denial-reason-${index}.credit-denial-checkbox`,
  getBorrowerCheckboxId: (index, borrowerIndex) =>
    `denial-reason-${index}.borrower-${borrowerIndex}-checkbox`,
  getDeleteButtonId: index => `denial-reason-${index}.delete-button`,
};
